import { getRoute, paths } from '../constants/strings';

export const capatalizeFirstLetter = (string) => {
  const lower = string?.toLowerCase();
  return lower?.charAt(0)?.toUpperCase() + lower?.slice(1);
};

export const isValidPassword = (password) => {
  let valid = true;
  let reason = '';

  if (password.length < 8) {
    valid = false;
    reason = 'Password must be at least 8 characters long';
  } else if (!/([a-z])$/.test(password)) {
    valid = false;
    reason = 'Password must contain at least one lowercase letter';
  } else if (!/([A-Z])$/.test(password)) {
    valid = false;
    reason = 'Password must contain at least one uppercase letter';
  }

  return { valid, reason };
};

export const truncate = (input, length) =>
  (input?.length || 0) > length ? `${input.substring(0, length)}...` : input;

export const convertToHumanReadable = (input) => {
  const rough = input.replace('_', ' ').toLowerCase();
  return rough.charAt(0).toUpperCase() + rough.slice(1);
};

export const vehicleString = (vehicle) => {
  const parts = [];
  if (!!vehicle?.unitNumber) {
    parts.push(vehicle.unitNumber);
  }
  if (!!vehicle?.year) {
    parts.push(vehicle.year);
  }
  if (!!vehicle?.make) {
    parts.push(vehicle.make);
  }
  if (!!vehicle?.model) {
    parts.push(vehicle.model);
  }

  return parts?.length
    ? parts.join(' ')
    : `${vehicle.type}-${vehicle.subtype}: ${vehicle.id}`;
};

export const generateTaskTargetString = (task) => {
  const { target, targetInterval, targetPeriod } = task;

  if (!target || !targetInterval || !targetPeriod) {
    return 'Target not set';
  }

  const interval = targetInterval !== 1 ? `${targetInterval} ` : '';
  const period = `${targetPeriod.toLowerCase()}${
    targetInterval > 1 ? 's' : ''
  }`;
  return `${target} every ${interval}${period}`;
};

export const internalTypes = { recordedMeeting: 'RECORDED_MEETING' };

export const navigationRoutes = (type, workspace) => {
  let route = getRoute(workspace.id, paths.assessments);
  switch (type) {
    case 'AUDIT':
      route = `/${paths.audits}`;
      break;
    case 'INCIDENT':
      route = `/${paths.incidents}`;
      break;
    case 'OBSERVATION':
      route = `/${paths.observations}`;
      break;
    case 'MOC':
    case 'QUALITY':
      route = getRoute(workspace.id, paths.quality);
      break;
    default:
      route = getRoute(workspace.id, paths.dashboard);
      break;
  }
  return route;
};
